import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class LayoutAPI extends ComponentAPI {
    getRows() {
        return this.state.rows;
    }
    setRows(rows) {
        this.setState({ rows });
    }
    getColumns() {
        return this.state.columns;
    }
    setColumns(columns) {
        this.setState({ columns });
    }
    getRowGap() {
        return this.state.rowGap;
    }
    setRowGap(rowGap) {
        this.setState({ rowGap });
    }
    getColumnGap() {
        return this.state.columnGap;
    }
    setColumnGap(columnGap) {
        this.setState({ columnGap });
    }
    getAlignItems() {
        return this.state.alignItems;
    }
    setAlignItems(alignItems) {
        this.setState({ alignItems });
    }
    getJustifyItems() {
        return this.state.justifyItems;
    }
    setJustifyItems(justifyItems) {
        this.setState({ justifyItems });
    }
    getLayoutAlign() {
        return this.state.alignContent;
    }
    setLayoutAlign(alignContent) {
        this.setState({ alignContent });
    }
    getJustifyContent() {
        return this.state.justifyContent;
    }
    setJustifyContent(justifyContent) {
        this.setState({ justifyContent });
    }
    getTemplateAreas() {
        return this.state.templateAreas;
    }
    setTemplateAreas(templateAreas) {
        this.setState({ templateAreas });
    }
}
export { LayoutAPI, };
//# sourceMappingURL=layout-api.js.map